"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isErrorWithMessage = exports.processErrors = exports.SynapseLoginError = exports.SocialClientTooManyRequestsError = exports.SocialClientInternalServerError = exports.SocialClientForbiddenError = exports.SocialClientBadRequestError = exports.SocialClientUnauthorizedError = void 0;
class SocialClientUnauthorizedError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.SocialClientUnauthorizedError = SocialClientUnauthorizedError;
class SocialClientBadRequestError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.SocialClientBadRequestError = SocialClientBadRequestError;
class SocialClientForbiddenError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.SocialClientForbiddenError = SocialClientForbiddenError;
class SocialClientInternalServerError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.SocialClientInternalServerError = SocialClientInternalServerError;
class SocialClientTooManyRequestsError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.SocialClientTooManyRequestsError = SocialClientTooManyRequestsError;
class SynapseLoginError extends Error {
    constructor(message) {
        super(`The synapse token could not be retrieved: ${message}`);
    }
}
exports.SynapseLoginError = SynapseLoginError;
function processErrors(response) {
    if (response.badRequestError) {
        throw new SocialClientBadRequestError(response.badRequestError.message);
    }
    else if (response.forbiddenError) {
        throw new SocialClientForbiddenError(response.forbiddenError.message);
    }
    else if (response.internalServerError) {
        throw new SocialClientInternalServerError(response.internalServerError.message);
    }
    else if (response.tooManyRequestsError) {
        throw new SocialClientTooManyRequestsError(response.tooManyRequestsError.message);
    }
    else if (response.unauthorizedError) {
        throw new SocialClientUnauthorizedError(response.unauthorizedError.message);
    }
}
exports.processErrors = processErrors;
function isErrorWithMessage(error) {
    return error !== undefined && error !== null && typeof error === 'object' && 'message' in error;
}
exports.isErrorWithMessage = isErrorWithMessage;
//# sourceMappingURL=errors.js.map